//@ts-check
import {CustomDataTable} from '@/components/organisms'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useComboProductTable} from '@/hooks/productCombo/useComboProductTable'
import {ProductComboSteps} from '@/types/productComboTypes'
import {comboProductTableColumnsWithQuantity} from '@/utils/productCombo/productComboConstants'
import {useMemo} from 'react'
import {ComboReviewSection} from './ComboReviewSection'

const TABLE_PAGE_SIZE = 4

export const ComboReviewProducts = () => {
  const {
    productCombo: {comboSkus},
  } = useProductCombo()
  const {data, setSortingObj, setSearchArry, onPageIndexChange, isLoading, handleResetAll} =
    useComboProductTable(TABLE_PAGE_SIZE)

  const records = useMemo(() => {
    const quantityByProductId = new Map((comboSkus || []).map(({productId, quantity}) => [productId, quantity]))

    return (data?.data || []).map(record => ({
      ...record,
      quantity: quantityByProductId.get(record.productId) ?? record.quantity ?? null,
    }))
  }, [comboSkus, data?.data])

  return (
    <ComboReviewSection
      label="Products"
      step={ProductComboSteps.PRODUCTS}
      content={
        <div className="flex w-full flex-col gap-6 overflow-hidden">
          <CustomDataTable
            columns={comboProductTableColumnsWithQuantity}
            records={records}
            setSearchArry={setSearchArry}
            handleSorting={setSortingObj}
            setPageIndex={onPageIndexChange}
            totalRecords={data?.totalRecords || 0}
            pageSize={TABLE_PAGE_SIZE}
            onResetAll={handleResetAll}
            enableSelection={false}
            isLoading={isLoading}
            showActions={false}
            id="productId"
            showResetAll={false}
            enableSorting={false}
            showColumnFilters={false}
            isSelectAll={false}
            setSelectAll={() => {}}
            defaultSortConfig={{key: 'productId', direction: 'desc'}}
          />
        </div>
      }
    />
  )
}
